"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    actions
  } = props;
  return {
    get: (0, _redux.bindActionCreators)(actions.get, dispatch)
    // clearSingle: bindActionCreators(actions.clearSingle, dispatch),
  };
};
class BaseShow extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "get", props => {
      const {
        [props.entity.plural]: store,
        id,
        match,
        entity
      } = props;
      const {
        single
      } = store;
      const _id = id || match.params[entity.singular];
      if (_id && !single.error && (!single.fetching && !single.fetched || single.data && single.data.Id !== _id)) {
        this.props.get(_id, {
          expand: store.expand
        }, module);
      }
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        entity,
        [this.props.entity.plural]: store,
        ...rest
      } = this.props;
      return _react.default.cloneElement(children, {
        ...rest,
        schema: store.single.schema,
        fields: (0, _helpers.mapSchemaToFields)(store.single.schema),
        editable: store.editable,
        [entity.singular]: store.single,
        [entity.plural]: store
      });
    });
  }
  componentDidMount() {
    this.get(this.props);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.get(nextProps);
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseShow);
module.exports = exports.default;